import { useScreensRoute } from './useScreensRoute';

/**
 * - 모든 페이지에 있지만, 타입 추론을 위해 useScreensRoute<'BrandHome'>와 같이 사용합니다.
 */
export const useGetCommonParams = () => {
  const {
    params: { instanceId, next_token, screen_name },
  } = useScreensRoute<'BrandHome'>();

  return {
    instanceId,
    nextToken: next_token,
    screenName: screen_name,
  };
};
